/* Custom Flower Face theme JS */
(function () {
  "use strict";

  var routes = window.themeRoutes || {
    cart: "/cart.js",
    cartAdd: "/cart/add.js",
    cartChange: "/cart/change.js",
    checkout: "/checkout",
  };

  function formatMoney(cents) {
    return "$" + (cents / 100).toFixed(2);
  }

  /* ==================================================================
     Mockup engine — placement comes from the per-product
     data-mockup-config JSON emitted by sections/main-product.liquid.
     The resolved placement is also written into hidden _preview_* line
     item properties at submit time so the cart drawer can rebuild the
     same composite.
     ================================================================== */

  function mockupNum(value, fallback) {
    var n = parseFloat(value);
    return isFinite(n) ? n : fallback;
  }

  function parseMockupConfig(el) {
    try {
      return JSON.parse(el.getAttribute("data-mockup-config") || "{}");
    } catch (err) {
      return {};
    }
  }

  function resolvePlacement(root, config) {
    var w = mockupNum(config.w, 84);
    var placement = {
      base: config.base || "",
      x: mockupNum(config.x, 50),
      y: mockupNum(config.y, 50),
      w: w,
      h: mockupNum(config.h, w),
      rotate: mockupNum(config.rotate, 0),
      shape: config.shape || "ellipse",
      finish: config.finish || "print",
      bg: config.bg || "keep",
    };

    var checked = root.querySelector("input[data-swatch]:checked");
    var name = checked ? (checked.getAttribute("data-swatch-name") || "") : "";
    var colors = config.colors || {};
    var override = null;
    if (name) {
      if (colors[name]) {
        override = colors[name];
      } else {
        var lower = name.toLowerCase();
        for (var key in colors) {
          if (lower === key.toLowerCase() || lower.indexOf(key.toLowerCase()) !== -1) {
            override = colors[key];
            break;
          }
        }
      }
    }
    if (override) {
      if (override.base === "NONE") placement.base = "";
      else if (override.base) placement.base = override.base;
      if (override.x) placement.x = mockupNum(override.x, placement.x);
      if (override.y) placement.y = mockupNum(override.y, placement.y);
      if (override.w) {
        placement.w = mockupNum(override.w, placement.w);
        placement.h = override.h ? mockupNum(override.h, placement.w) : placement.w;
      } else if (override.h) {
        placement.h = mockupNum(override.h, placement.h);
      }
      if (override.rotate !== undefined && override.rotate !== "" && override.rotate !== null) {
        placement.rotate = mockupNum(override.rotate, placement.rotate);
      }
      if (override.shape) placement.shape = override.shape;
      if (override.finish) placement.finish = override.finish;
      if (override.bg) placement.bg = override.bg;
    }
    return placement;
  }

  function applyPlacement(mockupEl, placement) {
    var bg = mockupEl.querySelector("[data-mockup-bg]");
    var face = mockupEl.querySelector("[data-mockup-face]");

    mockupEl.className = mockupEl.className
      .replace(/mockup-preview--shape-\S+/g, "")
      .replace(/mockup-preview--finish-\S+/g, "")
      .replace(/mockup-preview--plain/g, "")
      .replace(/\s+/g, " ")
      .trim();
    mockupEl.classList.add("mockup-preview--shape-" + placement.shape);
    mockupEl.classList.add("mockup-preview--finish-" + placement.finish);

    if (placement.base) {
      if (bg) {
        bg.hidden = false;
        if (bg.getAttribute("src") !== placement.base) bg.src = placement.base;
      }
      if (face) {
        face.style.top = placement.y + "%";
        face.style.left = placement.x + "%";
        face.style.width = placement.w + "%";
        face.style.height = placement.h + "%";
        face.style.transform = "translate(-50%, -50%) rotate(" + (placement.rotate || 0) + "deg)";
      }
    } else {
      mockupEl.classList.add("mockup-preview--plain");
      if (bg) bg.hidden = true;
      if (face) {
        face.style.top = "50%";
        face.style.left = "50%";
        face.style.width = "84%";
        face.style.height = "84%";
        face.style.transform = "translate(-50%, -50%)";
      }
    }
  }

  function injectPreviewProps(form, placement, crop) {
    var fields = {
      _preview_base: placement.base,
      _preview_x: placement.x,
      _preview_y: placement.y,
      _preview_w: placement.w,
      _preview_h: placement.h,
      _preview_rotate: placement.rotate || 0,
      _preview_shape: placement.shape,
      _preview_finish: placement.finish,
      _preview_bg: placement.bg || "keep",
    };
    if (crop) {
      fields._preview_cx = crop.x.toFixed(4);
      fields._preview_cy = crop.y.toFixed(4);
      fields._preview_cw = crop.w.toFixed(4);
      fields._preview_ch = crop.h.toFixed(4);
    }
    for (var key in fields) {
      var input = form.querySelector('input[name="properties[' + key + ']"]');
      if (!input) {
        input = document.createElement("input");
        input.type = "hidden";
        input.name = "properties[" + key + "]";
        form.appendChild(input);
      }
      input.value = fields[key];
    }
  }

  function escapeHTML(value) {
    return String(value).replace(/[&<>"']/g, function (ch) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[ch];
    });
  }

  /* CSS crop: renders the face-detected square of the photo inside the
     face area without re-encoding the image. */
  function cropStyleString(cx, cy, cw, ch) {
    if (!(cw > 0) || !(ch > 0)) return "";
    return (
      "position:absolute;max-width:none;object-fit:fill;" +
      "width:" + (100 / cw).toFixed(2) + "%;" +
      "height:" + (100 / ch).toFixed(2) + "%;" +
      "left:" + (-(cx / cw) * 100).toFixed(2) + "%;" +
      "top:" + (-(cy / ch) * 100).toFixed(2) + "%;"
    );
  }

  function applyCropStyles(img, crop) {
    if (!img) return;
    if (!crop) {
      img.style.position = "";
      img.style.maxWidth = "";
      img.style.objectFit = "";
      img.style.width = "";
      img.style.height = "";
      img.style.left = "";
      img.style.top = "";
      return;
    }
    img.style.position = "absolute";
    img.style.maxWidth = "none";
    img.style.objectFit = "fill";
    img.style.width = (100 / crop.w).toFixed(2) + "%";
    img.style.height = (100 / crop.h).toFixed(2) + "%";
    img.style.left = (-(crop.x / crop.w) * 100).toFixed(2) + "%";
    img.style.top = (-(crop.y / crop.h) * 100).toFixed(2) + "%";
  }

  /* Finished die-cut sticker markup for a cart line (photo already cut). */
  function cartStickerHTML(cutUrl) {
    return (
      '<div class="mockup-preview mockup-preview--shape-sticker mockup-preview--finish-print mockup-preview--plain has-photo">' +
      '<div class="mockup-preview__face is-cutout" style="top:50%;left:50%;width:94%;height:94%;transform:translate(-50%,-50%);">' +
      '<img src="' + escapeHTML(cutUrl) + '" alt="Your sticker">' +
      "</div></div>"
    );
  }

  /* Cutouts already computed this session, keyed by photo URL, so the
     drawer doesn't re-run segmentation on every render. */
  var stickerCutCache = {};

  /* Darkened-background versions already computed this session, keyed by
     photo URL, so the drawer doesn't reprocess on every render. */
  var darkBgCache = {};

  function cartItemMediaHTML(item) {
    var props = item.properties || {};
    var photoUrl = null;
    for (var key in props) {
      if (key.charAt(0) === "_" || !props[key]) continue;
      if (/^https?:\/\//.test(String(props[key]))) {
        photoUrl = String(props[key]);
        break;
      }
    }

    if (photoUrl) {
      if (String(props._preview_shape) === "sticker") {
        var cached = stickerCutCache[photoUrl];
        if (cached && cached !== "pending") return cartStickerHTML(cached);
      }
      var base = props._preview_base ? String(props._preview_base) : "";
      var w = mockupNum(props._preview_w, 84);
      var x = mockupNum(props._preview_x, 50);
      var y = mockupNum(props._preview_y, 50);
      var h = mockupNum(props._preview_h, w);
      var rot = mockupNum(props._preview_rotate, 0);
      var shape = props._preview_shape ? String(props._preview_shape) : "ellipse";
      var finish = props._preview_finish ? String(props._preview_finish) : "print";
      if (!base) { x = 50; y = 50; w = 84; h = 84; rot = 0; }
      var imgStyle = cropStyleString(
        mockupNum(props._preview_cx, -1),
        mockupNum(props._preview_cy, -1),
        mockupNum(props._preview_cw, 0),
        mockupNum(props._preview_ch, 0)
      );
      return (
        '<div class="mockup-preview mockup-preview--shape-' + escapeHTML(shape) +
        " mockup-preview--finish-" + escapeHTML(finish) +
        (base ? "" : " mockup-preview--plain") + ' has-photo">' +
        (base ? '<img class="mockup-preview__bg" src="' + escapeHTML(base) + '" alt="">' : "") +
        '<div class="mockup-preview__face" style="top:' + y + "%;left:" + x + "%;width:" + w + "%;height:" + h +
        "%;transform:translate(-50%,-50%) rotate(" + rot + 'deg);">' +
        '<img src="' + escapeHTML(photoUrl) + '"' + (imgStyle ? ' style="' + imgStyle + '"' : "") + ' alt="Uploaded photo">' +
        "</div></div>"
      );
    }
    return item.image ? '<img src="' + escapeHTML(item.image) + '&width=160" alt="">' : "";
  }

  /* ==================================================================
     Sticker cutout — for shape:"sticker" products (air freshener).
     Accepts a File (product page) or an https URL (cart drawer — the
     uploaded photo already lives on Shopify's CDN, which allows CORS).
     ================================================================== */
  var selfieSegPromise = null;
  function loadSelfieSeg() {
    if (selfieSegPromise) return selfieSegPromise;
    selfieSegPromise = new Promise(function (resolve, reject) {
      var s = document.createElement("script");
      s.src = "https://cdn.jsdelivr.net/npm/@mediapipe/selfie_segmentation/selfie_segmentation.js";
      s.onload = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
    }).then(function () {
      var seg = new window.SelfieSegmentation({
        locateFile: function (f) {
          return "https://cdn.jsdelivr.net/npm/@mediapipe/selfie_segmentation/" + f;
        },
      });
      seg.setOptions({ modelSelection: 1 });
      return seg;
    });
    return selfieSegPromise;
  }

  /* MediaPipe instances are singletons: two concurrent jobs would
     overwrite each other's onResults callback and hang. Serialize. */
  var segQueue = Promise.resolve();
  function withSegLock(task) {
    var run = segQueue.then(task);
    segQueue = run.catch(function () {});
    return run;
  }
  var fdQueue = Promise.resolve();
  function withFdLock(task) {
    var run = fdQueue.then(task);
    fdQueue = run.catch(function () {});
    return run;
  }

  function refineMask(mask, w, h) {
    var mctx = mask.getContext("2d");
    var d = mctx.getImageData(0, 0, w, h);
    var a = new Uint8Array(w * h);
    for (var i = 0; i < w * h; i++) a[i] = d.data[i * 4 + 3] ? 1 : 0;

    var labels = new Int32Array(w * h);
    var stack = new Int32Array(w * h);
    var best = 0, bestSize = 0, next = 0;
    for (var p = 0; p < w * h; p++) {
      if (!a[p] || labels[p]) continue;
      next++;
      var size = 0, top = 0;
      stack[top++] = p;
      labels[p] = next;
      while (top) {
        var q = stack[--top];
        size++;
        var qx = q % w;
        if (qx > 0 && a[q - 1] && !labels[q - 1]) { labels[q - 1] = next; stack[top++] = q - 1; }
        if (qx < w - 1 && a[q + 1] && !labels[q + 1]) { labels[q + 1] = next; stack[top++] = q + 1; }
        if (q >= w && a[q - w] && !labels[q - w]) { labels[q - w] = next; stack[top++] = q - w; }
        if (q < w * (h - 1) && a[q + w] && !labels[q + w]) { labels[q + w] = next; stack[top++] = q + w; }
      }
      if (size > bestSize) { bestSize = size; best = next; }
    }
    for (var j = 0; j < w * h; j++) {
      d.data[j * 4 + 3] = a[j] && labels[j] === best ? 255 : 0;
    }
    mctx.putImageData(d, 0, 0);

    var sm = document.createElement("canvas");
    sm.width = w; sm.height = h;
    var sctx = sm.getContext("2d");
    sctx.filter = "blur(" + Math.max(2, Math.round(Math.max(w, h) / 250)) + "px)";
    sctx.drawImage(mask, 0, 0);
    sctx.filter = "none";
    var sd = sctx.getImageData(0, 0, w, h);
    for (var k = 0; k < w * h; k++) {
      var v = sd.data[k * 4 + 3];
      sd.data[k * 4 + 3] = v < 90 ? 0 : v > 170 ? 255 : Math.round(((v - 90) / 80) * 255);
    }
    sctx.putImageData(sd, 0, 0);
    return sm;
  }

  function makeStickerCutout(source) {
    return withSegLock(function () {
      return loadSelfieSeg()
      .then(function (seg) {
        return new Promise(function (resolve) {
          var img = new Image();
          img.onload = function () {
            var scale = Math.min(1, 900 / Math.max(img.width, img.height));
            var w = Math.round(img.width * scale);
            var h = Math.round(img.height * scale);
            var src = document.createElement("canvas");
            src.width = w; src.height = h;
            src.getContext("2d").drawImage(img, 0, 0, w, h);

            var done = false;
            var timer = setTimeout(function () {
              if (!done) { done = true; resolve(null); }
            }, 15000);

            seg.onResults(function (results) {
              if (done) return;
              done = true;
              clearTimeout(timer);
              try {
                var mask = document.createElement("canvas");
                mask.width = w; mask.height = h;
                var mctx = mask.getContext("2d");
                mctx.drawImage(results.segmentationMask, 0, 0, w, h);
                var d = mctx.getImageData(0, 0, w, h);
                var on = 0;
                for (var i = 0; i < d.data.length; i += 4) {
                  if (d.data[i] > 175) { d.data[i + 3] = 255; on++; }
                  else { d.data[i + 3] = 0; }
                }
                var coverage = on / (w * h);
                if (coverage < 0.05 || coverage > 0.97) { resolve(null); return; }
                mctx.putImageData(d, 0, 0);

                var smooth = refineMask(mask, w, h);

                var cut = document.createElement("canvas");
                cut.width = w; cut.height = h;
                var cctx = cut.getContext("2d");
                cctx.drawImage(smooth, 0, 0);
                cctx.globalCompositeOperation = "source-in";
                cctx.drawImage(src, 0, 0);

                var sil = document.createElement("canvas");
                sil.width = w; sil.height = h;
                var sctx = sil.getContext("2d");
                sctx.drawImage(smooth, 0, 0);
                sctx.globalCompositeOperation = "source-in";
                sctx.fillStyle = "#fff";
                sctx.fillRect(0, 0, w, h);

                var rim = Math.max(5, Math.round(Math.max(w, h) * 0.025));
                var pad = rim * 2 + 4;
                var out = document.createElement("canvas");
                out.width = w + pad * 2; out.height = h + pad * 2;
                var octx = out.getContext("2d");
                for (var a2 = 0; a2 < 32; a2++) {
                  var ang = (a2 / 32) * Math.PI * 2;
                  octx.drawImage(sil, pad + Math.cos(ang) * rim, pad + Math.sin(ang) * rim);
                }
                octx.drawImage(cut, pad, pad);
                out.toBlob(function (blob) {
                  resolve(blob ? URL.createObjectURL(blob) : null);
                }, "image/png");
              } catch (err) {
                resolve(null);
              }
            });
            seg.send({ image: src }).catch(function () {
              if (!done) { done = true; resolve(null); }
            });
          };
          img.onerror = function () { resolve(null); };
          if (typeof source === "string") {
            img.crossOrigin = "anonymous";
            img.src = source;
          } else {
            img.src = URL.createObjectURL(source);
          }
        });
      });
    })
      .catch(function () { return null; });
  }


  /* ==================================================================
     Head cutout — for products where the photo replaces the printed
     head (pillow). Segments the person, keeps head + hair only, cuts
     just under the chin with a soft fade, and returns a transparent
     PNG blob URL sized to the head bounds. Accepts a File or an https
     URL (cart drawer). Resolves null on any failure so callers can
     fall back to the circle crop.
     ================================================================== */
  var headCutCache = {};
  function makeHeadCutout(source, crops) {
    var cropsPromise = crops !== undefined ? Promise.resolve(crops) : detectFaceCrop(source);
    return cropsPromise
      .then(function (detected) {
        return withSegLock(function () {
          return loadSelfieSeg().then(function (seg) {
            return new Promise(function (resolve) {
              var img = new Image();
              img.onload = function () {
                var scale = Math.min(1, 900 / Math.max(img.width, img.height));
                var w = Math.round(img.width * scale);
                var h = Math.round(img.height * scale);
                var src = document.createElement("canvas");
                src.width = w; src.height = h;
                src.getContext("2d").drawImage(img, 0, 0, w, h);

                var chinY = null;
                var faceBox = null;
                if (detected && detected.bb) {
                  faceBox = {
                    x: detected.bb.x * w,
                    y: detected.bb.y * h,
                    w: detected.bb.w * w,
                    h: detected.bb.h * h,
                  };
                  chinY = faceBox.y + faceBox.h * 1.12;
                }

                var done = false;
                var timer = setTimeout(function () {
                  if (!done) { done = true; resolve(null); }
                }, 20000);

                seg.onResults(function (segResults) {
                  if (done) return;
                  done = true;
                  clearTimeout(timer);
                  try {
                    var mask = document.createElement("canvas");
                    mask.width = w; mask.height = h;
                    var mctx = mask.getContext("2d");
                    mctx.drawImage(segResults.segmentationMask, 0, 0, w, h);
                    var d = mctx.getImageData(0, 0, w, h);
                    var on = 0;
                    for (var i = 0; i < d.data.length; i += 4) {
                      if (d.data[i] > 175) { d.data[i + 3] = 255; on++; }
                      else { d.data[i + 3] = 0; }
                    }
                    var coverage = on / (w * h);
                    if (coverage < 0.05 || coverage > 0.97) { resolve(null); return; }
                    mctx.putImageData(d, 0, 0);
                    var smooth = refineMask(mask, w, h);

                    var md = smooth.getContext("2d").getImageData(0, 0, w, h).data;
                    var bottom = chinY !== null ? Math.max(20, Math.min(h, Math.round(chinY))) : h;
                    var minX = w, maxX = 0, minY = h;
                    for (var y = 0; y < bottom; y++) {
                      for (var x = 0; x < w; x++) {
                        if (md[(y * w + x) * 4 + 3] > 40) {
                          if (x < minX) minX = x;
                          if (x > maxX) maxX = x;
                          if (y < minY) minY = y;
                        }
                      }
                    }
                    if (maxX <= minX || minY >= bottom) { resolve(null); return; }
                    if (faceBox) {
                      minX = Math.min(minX, Math.max(0, Math.round(faceBox.x)));
                      maxX = Math.max(maxX, Math.min(w, Math.round(faceBox.x + faceBox.w)));
                    }
                    var padX = Math.round((maxX - minX) * 0.03) + 2;
                    minX = Math.max(0, minX - padX);
                    maxX = Math.min(w, maxX + padX);
                    minY = Math.max(0, minY - padX);
                    var cw = maxX - minX, ch = bottom - minY;
                    if (cw < 20 || ch < 20) { resolve(null); return; }

                    var cut = document.createElement("canvas");
                    cut.width = cw; cut.height = ch;
                    var cctx = cut.getContext("2d");
                    cctx.drawImage(smooth, minX, minY, cw, ch, 0, 0, cw, ch);
                    cctx.globalCompositeOperation = "source-in";
                    cctx.drawImage(src, minX, minY, cw, ch, 0, 0, cw, ch);
                    /* Fade the neck cut so it does not end in a hard line. */
                    cctx.globalCompositeOperation = "destination-out";
                    var fadeH = Math.max(6, Math.round(ch * 0.08));
                    var grad = cctx.createLinearGradient(0, ch - fadeH, 0, ch);
                    grad.addColorStop(0, "rgba(0,0,0,0)");
                    grad.addColorStop(1, "rgba(0,0,0,0.95)");
                    cctx.fillStyle = grad;
                    cctx.fillRect(0, ch - fadeH, cw, fadeH);
                    cut.toBlob(function (blob) {
                      resolve(blob ? URL.createObjectURL(blob) : null);
                    }, "image/png");
                  } catch (err) {
                    resolve(null);
                  }
                });
                seg.send({ image: src }).catch(function () {
                  if (!done) { done = true; resolve(null); }
                });
              };
              img.onerror = function () { resolve(null); };
              if (typeof source === "string") {
                img.crossOrigin = "anonymous";
                img.src = source;
              } else {
                img.src = URL.createObjectURL(source);
              }
            });
          });
        });
      })
      .catch(function () { return null; });
  }

  /* ==================================================================
     Dark background — for products printed on a dark base (labubu).
     Finds the plain white background by flood-filling near-white pixels
     inward from the photo's edges and paints it black. Because the fill
     starts at the edges, enclosed whites (teeth, eyes, shirt buttons)
     are never touched. Accepts a File (product page) or an https URL
     (cart drawer). Resolves to a blob URL, or null to keep the original.
     ================================================================== */
  function dilateMask(src, w, h, rad) {
    var tmp = new Uint8Array(w * h);
    var out = new Uint8Array(w * h);
    var x, y, k, i;
    for (y = 0; y < h; y++) {
      for (x = 0; x < w; x++) {
        i = y * w + x;
        if (src[i]) { tmp[i] = 1; continue; }
        for (k = 1; k <= rad; k++) {
          if ((x - k >= 0 && src[i - k]) || (x + k < w && src[i + k])) { tmp[i] = 1; break; }
        }
      }
    }
    for (y = 0; y < h; y++) {
      for (x = 0; x < w; x++) {
        i = y * w + x;
        if (tmp[i]) { out[i] = 1; continue; }
        for (k = 1; k <= rad; k++) {
          if ((y - k >= 0 && tmp[i - k * w]) || (y + k < h && tmp[i + k * w])) { out[i] = 1; break; }
        }
      }
    }
    return out;
  }

  function makeDarkBackground(source) {
    return new Promise(function (resolve) {
      var img = new Image();
      img.onload = function () {
        try {
          var scale = Math.min(1, 900 / Math.max(img.width, img.height));
          var w = Math.round(img.width * scale);
          var h = Math.round(img.height * scale);
          var cnv = document.createElement("canvas");
          cnv.width = w; cnv.height = h;
          var ctx = cnv.getContext("2d");
          ctx.drawImage(img, 0, 0, w, h);
          var data = ctx.getImageData(0, 0, w, h).data;

          /* Near-white, low-saturation pixels are background candidates. */
          var near = new Uint8Array(w * h);
          for (var i = 0; i < w * h; i++) {
            var r = data[i * 4], g = data[i * 4 + 1], b = data[i * 4 + 2];
            var mx = Math.max(r, g, b), mn = Math.min(r, g, b);
            if (mx > 150 && mx - mn < 40) near[i] = 1;
          }

          var mask = new Uint8Array(w * h);
          var stack = new Int32Array(w * h);
          var top = 0;
          function seed(p) { if (near[p] && !mask[p]) { mask[p] = 1; stack[top++] = p; } }
          function flood() {
            while (top) {
              var q = stack[--top];
              var qx = q % w;
              if (qx > 0) seed(q - 1);
              if (qx < w - 1) seed(q + 1);
              if (q >= w) seed(q - w);
              if (q < w * (h - 1)) seed(q + w);
            }
          }
          for (var x = 0; x < w; x++) { seed(x); seed((h - 1) * w + x); }
          for (var y = 0; y < h; y++) { seed(y * w); seed(y * w + w - 1); }
          flood();

          var on = 0;
          for (i = 0; i < w * h; i++) on += mask[i];
          /* No meaningful white border: photo isn't on a white background,
             leave it untouched. */
          if (on < w * h * 0.02) { resolve(null); return; }

          /* Let the fill jump hair strands so background pockets trapped
             between curls also go dark. */
          for (var pass = 0; pass < 4; pass++) {
            var grown = dilateMask(mask, w, h, 5);
            top = 0;
            for (i = 0; i < w * h; i++) {
              if (grown[i] && near[i] && !mask[i]) { mask[i] = 1; stack[top++] = i; }
            }
            flood();
          }

          var mc = document.createElement("canvas");
          mc.width = w; mc.height = h;
          var mctx = mc.getContext("2d");
          var md = mctx.createImageData(w, h);
          for (i = 0; i < w * h; i++) { if (mask[i]) md.data[i * 4 + 3] = 255; }
          mctx.putImageData(md, 0, 0);

          /* Expand the mask about a pixel onto the hair edge to swallow
             the white fringe, then soften and paint over the photo. */
          var soft = document.createElement("canvas");
          soft.width = w; soft.height = h;
          var sctx = soft.getContext("2d");
          for (var oa = 0; oa < 8; oa++) {
            var oang = (oa / 8) * Math.PI * 2;
            sctx.drawImage(mc, Math.cos(oang) * 1.2, Math.sin(oang) * 1.2);
          }
          sctx.filter = "blur(1.8px)";
          sctx.drawImage(mc, 0, 0);
          sctx.filter = "none";

          ctx.drawImage(soft, 0, 0);
          cnv.toBlob(function (blob) {
            resolve(blob ? URL.createObjectURL(blob) : null);
          }, "image/jpeg", 0.92);
        } catch (err) {
          resolve(null);
        }
      };
      img.onerror = function () { resolve(null); };
      if (typeof source === "string") {
        img.crossOrigin = "anonymous";
        img.src = source;
      } else {
        img.src = URL.createObjectURL(source);
      }
    });
  }

  /* ==================================================================
     Face auto-crop — for disc/print/engrave products (flower, labubu,
     pillow, bracelet). Detects the face on-device and zooms the preview
     to it. Returns {x,y,w,h} fractions of the image, or null.
     ================================================================== */
  var faceDetectPromise = null;
  function loadFaceDetect() {
    if (faceDetectPromise) return faceDetectPromise;
    faceDetectPromise = new Promise(function (resolve, reject) {
      var s = document.createElement("script");
      s.src = "https://cdn.jsdelivr.net/npm/@mediapipe/face_detection/face_detection.js";
      s.onload = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
    }).then(function () {
      var fd = new window.FaceDetection({
        locateFile: function (f) {
          return "https://cdn.jsdelivr.net/npm/@mediapipe/face_detection/" + f;
        },
      });
      fd.setOptions({ model: "short", minDetectionConfidence: 0.5 });
      return fd;
    });
    return faceDetectPromise;
  }

  function detectFaceCrop(file) {
    return withFdLock(function () {
      return loadFaceDetect()
      .then(function (fd) {
        return new Promise(function (resolve) {
          var img = new Image();
          img.onload = function () {
            var scale = Math.min(1, 700 / Math.max(img.width, img.height));
            var w = Math.round(img.width * scale);
            var h = Math.round(img.height * scale);
            var cnv = document.createElement("canvas");
            cnv.width = w; cnv.height = h;
            cnv.getContext("2d").drawImage(img, 0, 0, w, h);

            var done = false;
            var timer = setTimeout(function () {
              if (!done) { done = true; resolve(null); }
            }, 10000);

            fd.onResults(function (results) {
              if (done) return;
              done = true;
              clearTimeout(timer);
              try {
                var dets = results.detections || [];
                if (!dets.length) { resolve(null); return; }
                var det = dets[0];
                for (var i = 1; i < dets.length; i++) {
                  if (dets[i].boundingBox.width > det.boundingBox.width) det = dets[i];
                }
                var bb = det.boundingBox;
                var sidePx = Math.max(bb.width * w, bb.height * h) * 1.75;
                sidePx = Math.min(sidePx, w, h);
                var cxPx = bb.xCenter * w;
                var cyPx = bb.yCenter * h - sidePx * 0.16;
                var xPx = Math.min(Math.max(cxPx - sidePx / 2, 0), w - sidePx);
                var yPx = Math.min(Math.max(cyPx - sidePx / 2, 0), h - sidePx);
                var crops = {
                  face: { x: xPx / w, y: yPx / h, w: sidePx / w, h: sidePx / h },
                  eyes: null,
                  bb: {
                    x: bb.xCenter - bb.width / 2,
                    y: bb.yCenter - bb.height / 2,
                    w: bb.width,
                    h: bb.height,
                  },
                };
                /* Eye strip for engraved-bar products: landmarks 0 and 1
                   are the right and left eye. */
                var lms = det.landmarks || [];
                if (lms.length >= 2) {
                  var exC = ((lms[0].x + lms[1].x) / 2) * w;
                  var eyC = ((lms[0].y + lms[1].y) / 2) * h;
                  var dist = Math.abs(lms[0].x - lms[1].x) * w;
                  if (dist > 4) {
                    var ew = Math.min(dist * 3.2, w);
                    var eh = Math.min(dist * 1.1, h);
                    var ex = Math.min(Math.max(exC - ew / 2, 0), w - ew);
                    var ey = Math.min(Math.max(eyC - eh / 2, 0), h - eh);
                    crops.eyes = { x: ex / w, y: ey / h, w: ew / w, h: eh / h };
                  }
                }
                resolve(crops);
              } catch (err) {
                resolve(null);
              }
            });
            fd.send({ image: cnv }).catch(function () {
              if (!done) { done = true; resolve(null); }
            });
          };
          img.onerror = function () { resolve(null); };
          if (typeof file === "string") {
            img.crossOrigin = "anonymous";
            img.src = file;
          } else {
            img.src = URL.createObjectURL(file);
          }
        });
      });
    })
      .catch(function () { return null; });
  }

  /* ---------- Preview lightbox: click the mockup to see it large ----- */
  var mockupLightbox = null;
  function openMockupLightbox(mockupEl) {
    if (!mockupLightbox) {
      mockupLightbox = document.createElement("div");
      mockupLightbox.className = "mockup-lightbox";
      mockupLightbox.addEventListener("click", function () {
        mockupLightbox.classList.remove("is-open");
        mockupLightbox.innerHTML = "";
      });
      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape") {
          mockupLightbox.classList.remove("is-open");
          mockupLightbox.innerHTML = "";
        }
      });
      document.body.appendChild(mockupLightbox);
    }
    mockupLightbox.innerHTML = "";
    var clone = mockupEl.cloneNode(true);
    clone.removeAttribute("data-mockup-preview");
    mockupLightbox.appendChild(clone);
    var hint = document.createElement("p");
    hint.className = "mockup-lightbox__hint";
    hint.textContent = "Preview is approximate — click anywhere to close";
    mockupLightbox.appendChild(hint);
    mockupLightbox.classList.add("is-open");
  }

  /* ---------- Mobile menu ---------- */
  document.querySelectorAll("[data-menu-open]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var menu = document.getElementById("MobileMenu");
      if (menu) menu.classList.add("is-open");
    });
  });
  document.querySelectorAll("[data-menu-close]").forEach(function (el) {
    el.addEventListener("click", function () {
      var menu = document.getElementById("MobileMenu");
      if (menu) menu.classList.remove("is-open");
    });
  });

  /* ---------- Cart drawer ---------- */
  var drawer = document.getElementById("CartDrawer");

  var emptyStateHTML = (function () {
    var itemsEl = drawer && drawer.querySelector("[data-cart-items]");
    return itemsEl
      ? itemsEl.innerHTML
      : '<div class="cart-drawer__empty">Your cart is empty 🌸</div>';
  })();
  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add("is-open");
    document.body.style.overflow = "hidden";
    refreshCart();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove("is-open");
    document.body.style.overflow = "";
  }

  document.querySelectorAll("[data-cart-open]").forEach(function (btn) {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      openDrawer();
    });
  });
  document.querySelectorAll("[data-cart-close]").forEach(function (el) {
    el.addEventListener("click", closeDrawer);
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeDrawer();
  });

  function updateCartCount(count) {
    document.querySelectorAll("[data-cart-count]").forEach(function (el) {
      el.textContent = count;
      el.setAttribute("data-count", count);
    });
  }

  function updateShippingAndUpsell(cart) {
    if (!drawer) return;
    var bar = drawer.querySelector("[data-ship-bar]");
    if (bar) {
      var threshold = parseInt(bar.getAttribute("data-threshold"), 10) || 7500;
      bar.hidden = cart.item_count === 0;
      var msg = bar.querySelector("[data-ship-msg]");
      var fill = bar.querySelector("[data-ship-fill]");
      var remaining = threshold - cart.total_price;
      if (msg) {
        if (remaining > 0) {
          bar.classList.remove("is-unlocked");
          msg.innerHTML =
            "🚚 You're <strong>" + formatMoney(remaining) +
            "</strong> away from <strong>FREE shipping</strong>";
        } else {
          bar.classList.add("is-unlocked");
          msg.innerHTML = "🚚 <strong>You've unlocked FREE shipping!</strong>";
        }
      }
      if (fill) {
        fill.style.width =
          Math.min(100, (cart.total_price / threshold) * 100) + "%";
      }
      var shipRow = drawer.querySelector("[data-ship-row]");
      if (shipRow) shipRow.hidden = remaining > 0 || cart.item_count === 0;
    }

    /* Upsell card — only for a single-item cart, and the wording adapts:
       "add a 2nd one" when that item IS the upsell product, otherwise a
       cross-sell for the flower. */
    var upsell = drawer.querySelector("[data-upsell]");
    if (upsell) {
      upsell.hidden = cart.item_count !== 1;
      if (cart.item_count === 1) {
        var pairMode = cart.items[0].handle === (upsell.getAttribute("data-upsell-handle") || "");
        var modeName = pairMode ? "pair" : "cross";
        document.querySelectorAll("[data-upsell-mode]").forEach(function (el) {
          el.hidden = el.getAttribute("data-upsell-mode") !== modeName;
        });
      }
    }

    var checkoutLink = drawer.querySelector(".cart-drawer__checkout");
    if (checkoutLink) {
      var code = checkoutLink.getAttribute("data-discount-code");
      if (code && cart.item_count >= 2) {
        checkoutLink.href =
          "/discount/" + encodeURIComponent(code) + "?redirect=%2Fcheckout";
      } else {
        checkoutLink.href = routes.checkout;
      }
      var note = drawer.querySelector("[data-discount-note]");
      if (note) note.hidden = !(code && cart.item_count >= 2);
    }
  }
  function renderCart(cart) {
    updateCartCount(cart.item_count);
    if (!drawer) return;
    updateShippingAndUpsell(cart);
    var itemsEl = drawer.querySelector("[data-cart-items]");
    var subtotalEl = drawer.querySelector("[data-cart-subtotal]");
    var footEl = drawer.querySelector("[data-cart-foot]");
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    if (footEl) footEl.style.display = cart.item_count > 0 ? "" : "none";
    if (!itemsEl) return;

    if (cart.item_count === 0) {
      itemsEl.innerHTML = emptyStateHTML;
      return;
    }

    itemsEl.innerHTML = cart.items
      .map(function (item, index) {
        var props = "";
        for (var key in item.properties || {}) {
          if (key.charAt(0) === "_" || !item.properties[key]) continue;
          var value = String(item.properties[key]);
          if (/^https?:\/\//.test(value)) {
            value = '<a href="' + value + '" target="_blank" rel="noopener">View</a>';
          }
          props +=
            '<p class="cart-item__meta">' + key + ": " + value + "</p>";
        }
        return (
          '<div class="cart-item" data-line="' + (index + 1) + '">' +
          '<div class="cart-item__media">' +
          cartItemMediaHTML(item) +
          "</div>" +
          '<div class="cart-item__body">' +
          '<p class="cart-item__title">' + item.product_title + "</p>" +
          (item.variant_title
            ? '<p class="cart-item__meta">' + item.variant_title + "</p>"
            : "") +
          props +
          '<div class="cart-item__row">' +
          '<span class="cart-item__qty">' +
          '<button type="button" data-qty-change="-1" aria-label="Decrease quantity">−</button>' +
          "<span>" + item.quantity + "</span>" +
          '<button type="button" data-qty-change="1" aria-label="Increase quantity">+</button>' +
          "</span>" +
          '<span class="cart-item__price">' + formatMoney(item.final_line_price) + "</span>" +
          "</div>" +
          '<button type="button" class="cart-item__remove" data-qty-change="remove">Remove</button>' +
          "</div></div>"
        );
      })
      .join("");

    itemsEl.querySelectorAll("[data-qty-change]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var itemEl = btn.closest(".cart-item");
        var line = parseInt(itemEl.getAttribute("data-line"), 10);
        var qtyEl = itemEl.querySelector(".cart-item__qty span");
        var current = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
        var mode = btn.getAttribute("data-qty-change");
        var quantity =
          mode === "remove" ? 0 : Math.max(0, current + parseInt(mode, 10));
        changeLine(line, quantity);
      });
    });

    /* Sticker lines: rebuild the die-cut cutout from the uploaded photo
       (cached per URL) and swap it into the thumbnail, so the cart shows
       the same sticker the buyer approved on the product page. */
    cart.items.forEach(function (item, index) {
      var p2 = item.properties || {};
      if (String(p2._preview_shape) !== "sticker") return;
      var url2 = null;
      for (var k2 in p2) {
        if (k2.charAt(0) !== "_" && p2[k2] && /^https?:\/\//.test(String(p2[k2]))) {
          url2 = String(p2[k2]);
          break;
        }
      }
      if (!url2 || stickerCutCache[url2]) return;
      stickerCutCache[url2] = "pending";
      makeStickerCutout(url2).then(function (cutUrl) {
        if (!cutUrl) { delete stickerCutCache[url2]; return; }
        stickerCutCache[url2] = cutUrl;
        var mediaEl = itemsEl.querySelector('.cart-item[data-line="' + (index + 1) + '"] .cart-item__media');
        if (mediaEl) mediaEl.innerHTML = cartStickerHTML(cutUrl);
      });
    });

    /* Head-cutout lines (pillow): rebuild the segmented head from the
       uploaded photo (cached per URL) and swap it into the thumbnail. */
    cart.items.forEach(function (item, index) {
      var p4 = item.properties || {};
      if (String(p4._preview_shape) !== "headcut") return;
      var url4 = null;
      for (var k4 in p4) {
        if (k4.charAt(0) !== "_" && p4[k4] && /^https?:\/\//.test(String(p4[k4]))) {
          url4 = String(p4[k4]);
          break;
        }
      }
      if (!url4) return;
      var applyHeadCut = function (cutUrl) {
        var faceDiv = itemsEl.querySelector('.cart-item[data-line="' + (index + 1) + '"] .mockup-preview__face');
        if (!faceDiv) return;
        var im = faceDiv.querySelector("img");
        if (!im) return;
        im.removeAttribute("style");
        im.src = cutUrl;
        faceDiv.classList.add("is-cutout");
      };
      var knownHead = headCutCache[url4];
      if (knownHead === "pending") return;
      if (knownHead) { applyHeadCut(knownHead); return; }
      headCutCache[url4] = "pending";
      makeHeadCutout(url4).then(function (cutUrl) {
        if (!cutUrl) { delete headCutCache[url4]; return; }
        headCutCache[url4] = cutUrl;
        applyHeadCut(cutUrl);
      });
    });

    /* Dark-background lines: swap in the blacked-out version of the
       uploaded photo (cached per URL), so the cart shows the same
       preview the buyer approved on the product page. */
    cart.items.forEach(function (item, index) {
      var p3 = item.properties || {};
      if (String(p3._preview_bg) !== "black") return;
      if (String(p3._preview_shape) === "sticker") return;
      var url3 = null;
      for (var k3 in p3) {
        if (k3.charAt(0) !== "_" && p3[k3] && /^https?:\/\//.test(String(p3[k3]))) {
          url3 = String(p3[k3]);
          break;
        }
      }
      if (!url3) return;
      var faceSel = '.cart-item[data-line="' + (index + 1) + '"] .mockup-preview__face img';
      var known = darkBgCache[url3];
      if (known === "pending") return;
      if (known) {
        var fi0 = itemsEl.querySelector(faceSel);
        if (fi0) fi0.src = known;
        return;
      }
      darkBgCache[url3] = "pending";
      makeDarkBackground(url3).then(function (darkUrl) {
        if (!darkUrl) { delete darkBgCache[url3]; return; }
        darkBgCache[url3] = darkUrl;
        var fi = itemsEl.querySelector(faceSel);
        if (fi) fi.src = darkUrl;
      });
    });
  }

  function refreshCart() {
    fetch(routes.cart)
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () {});
  }

  function changeLine(line, quantity) {
    fetch(routes.cartChange, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ line: line, quantity: quantity }),
    })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () {});
  }

  refreshCart();

  /* ---------- Cart page: same composites as the drawer ----------
     sections/main-cart.liquid renders the mockup markup server-side and
     tags it; here we swap in the head cutout / sticker / dark version. */
  document.querySelectorAll("[data-cart-page-media]").forEach(function (el) {
    var shape = el.getAttribute("data-line-shape");
    var url = el.getAttribute("data-photo-url");
    var bg = el.getAttribute("data-preview-bg");
    if (!url) return;
    var faceDiv = el.querySelector(".mockup-preview__face");
    var im = faceDiv ? faceDiv.querySelector("img") : null;
    if (!im) return;
    if (shape === "headcut") {
      var applyCut = function (cutUrl) {
        im.removeAttribute("style");
        im.src = cutUrl;
        faceDiv.classList.add("is-cutout");
      };
      var known = headCutCache[url];
      if (known && known !== "pending") { applyCut(known); return; }
      headCutCache[url] = "pending";
      makeHeadCutout(url).then(function (cutUrl) {
        if (!cutUrl) { delete headCutCache[url]; return; }
        headCutCache[url] = cutUrl;
        applyCut(cutUrl);
      });
    } else if (shape === "sticker") {
      makeStickerCutout(url).then(function (cutUrl) {
        if (cutUrl) el.outerHTML = cartStickerHTML(cutUrl);
      });
    } else if (bg === "black") {
      makeDarkBackground(url).then(function (darkUrl) {
        if (darkUrl) im.src = darkUrl;
      });
    }
  });

  if (/[?&]cart=open/.test(window.location.search)) {
    openDrawer();
    if (window.history.replaceState) {
      window.history.replaceState({}, "", window.location.pathname);
    }
  }

  /* ---------- In-drawer quick-add popup (Add a 2nd flower) ---------- */
  var quickAdd = document.querySelector("[data-quick-add]");
  if (quickAdd) {
    var openQuickAdd = function () { quickAdd.classList.add("is-open"); };
    var closeQuickAdd = function () { quickAdd.classList.remove("is-open"); };

    document.querySelectorAll("[data-quick-add-open]").forEach(function (btn) {
      btn.addEventListener("click", openQuickAdd);
    });
    quickAdd.querySelectorAll("[data-quick-add-close]").forEach(function (el) {
      el.addEventListener("click", closeQuickAdd);
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closeQuickAdd();
    });

    var qaForm = quickAdd.querySelector("[data-quick-add-form]");
    if (qaForm) {
      var qaConfig = parseMockupConfig(qaForm);
      var qaFile = qaForm.querySelector("[data-photo-input]");
      var qaError = qaForm.querySelector("[data-form-error]");
      var qaLabel = qaForm.querySelector("[data-quick-add-label]");
      var qaSubmit = qaForm.querySelector(".quick-add__submit");
      var qaCrop = null;
      var qaCropToken = 0;

      var qaShowError = function (message) {
        if (!qaError) return alert(message);
        qaError.textContent = message;
        qaError.classList.add("is-visible");
      };

      if (qaFile) {
        var qaPreview = qaForm.querySelector("[data-photo-preview]");
        var qaPreviewImg = qaPreview ? qaPreview.querySelector("img") : null;
        var qaPreviewName = qaPreview ? qaPreview.querySelector("[data-photo-name]") : null;
        var qaRemove = qaPreview ? qaPreview.querySelector("[data-photo-remove]") : null;

        qaFile.addEventListener("change", function () {
          if (qaError) qaError.classList.remove("is-visible");
          var file = qaFile.files[0];
          if (!file) return;
          if (file.size > 20 * 1024 * 1024) {
            qaFile.value = "";
            qaShowError("That photo is larger than 20 MB. Please choose a smaller photo.");
            return;
          }
          if (qaPreview && qaPreviewImg) {
            qaPreviewImg.src = URL.createObjectURL(file);
            if (qaPreviewName) qaPreviewName.textContent = file.name;
            qaPreview.classList.add("has-photo");
          }
          qaCrop = null;
          var qaToken = ++qaCropToken;
          detectFaceCrop(file).then(function (res) {
            if (qaToken === qaCropToken) qaCrop = res ? res.face : null;
          });
          if (qaPreviewImg && resolvePlacement(qaForm, qaConfig).bg === "black") {
            makeDarkBackground(file).then(function (darkUrl) {
              if (darkUrl && qaToken === qaCropToken && qaFile.files.length) {
                qaPreviewImg.src = darkUrl;
              }
            });
          }
        });
        if (qaRemove) {
          qaRemove.addEventListener("click", function () {
            qaCropToken++;
            qaCrop = null;
            qaFile.value = "";
            qaPreview.classList.remove("has-photo");
          });
        }
      }

      qaForm.addEventListener("submit", function (e) {
        if (qaError) qaError.classList.remove("is-visible");
        if (qaFile && qaFile.files.length === 0) {
          e.preventDefault();
          qaShowError("Please upload a photo first!");
          return;
        }
        injectPreviewProps(qaForm, resolvePlacement(qaForm, qaConfig), qaCrop);
        var returnTo = qaForm.querySelector('input[name="return_to"]');
        if (!returnTo) {
          returnTo = document.createElement("input");
          returnTo.type = "hidden";
          returnTo.name = "return_to";
          qaForm.appendChild(returnTo);
        }
        returnTo.value = window.location.pathname + "?cart=open";
        if (qaSubmit) qaSubmit.setAttribute("disabled", "disabled");
        if (qaLabel) qaLabel.textContent = "Uploading your photo…";
      });
    }
  }

  /* ---------- Product form ---------- */
  document.querySelectorAll("[data-product-form]").forEach(function (form) {
    var errorEl = form.querySelector("[data-form-error]");
    var buyBtn = form.querySelector("[data-buy-button]");
    var buyLabel = buyBtn ? buyBtn.querySelector("[data-buy-label]") : null;
    var atcBtn = form.querySelector("[data-add-to-cart]");
    var atcLabel = atcBtn ? atcBtn.querySelector("[data-atc-label]") : null;
    var fileInput = form.querySelector('input[type="file"][data-photo-input]');
    var requirePhoto = form.hasAttribute("data-require-photo");
    var mockupEl = form.querySelector("[data-mockup-preview]");
    var mockupConfig = mockupEl ? parseMockupConfig(mockupEl) : {};
    var cutoutToken = 0;
    var faceCrop = null;

    function showError(message) {
      if (!errorEl) return alert(message);
      errorEl.textContent = message;
      errorEl.classList.add("is-visible");
    }
    function clearError() {
      if (errorEl) errorEl.classList.remove("is-visible");
    }

    function syncMockupPreview() {
      if (!mockupEl) return;
      applyPlacement(mockupEl, resolvePlacement(form, mockupConfig));
    }

    if (fileInput) {
      var preview = form.querySelector("[data-photo-preview]");
      var previewImg = preview
        ? preview.querySelector("[data-mockup-face] img") || preview.querySelector("img")
        : null;
      var previewName = preview ? preview.querySelector("[data-photo-name]") : null;
      var removeBtn = preview ? preview.querySelector("[data-photo-remove]") : null;
      var faceEl = form.querySelector("[data-mockup-face]");
      if (mockupEl) {
        mockupEl.addEventListener("click", function () {
          if (mockupEl.classList.contains("has-photo")) openMockupLightbox(mockupEl);
        });
      }

      syncMockupPreview();

      fileInput.addEventListener("change", function () {
        clearError();
        var file = fileInput.files[0];
        if (!file) return;
        if (file.size > 20 * 1024 * 1024) {
          fileInput.value = "";
          showError("That photo is larger than 20 MB. Please choose a smaller photo.");
          return;
        }
        if (preview && previewImg) {
          previewImg.src = URL.createObjectURL(file);
          if (previewName) previewName.textContent = file.name;
          preview.classList.add("has-photo");
          if (mockupEl) mockupEl.classList.add("has-photo");
          if (faceEl) faceEl.classList.remove("is-cutout");
          faceCrop = null;
          applyCropStyles(previewImg, null);
          syncMockupPreview();

          var token = ++cutoutToken;
          if (resolvePlacement(form, mockupConfig).shape === "headcut") {
            /* Interim circle while the cutout renders, then swap in the
               segmented head. The face detection runs once and its box is
               reused by the cutout for the chin line. */
            detectFaceCrop(file).then(function (res) {
              if (token !== cutoutToken || !fileInput.files.length) return;
              if (res && !(faceEl && faceEl.classList.contains("is-cutout"))) {
                faceCrop = res.face;
                applyCropStyles(previewImg, faceCrop);
              }
              makeHeadCutout(file, res).then(function (url) {
                if (url && token === cutoutToken && fileInput.files.length) {
                  applyCropStyles(previewImg, null);
                  previewImg.src = url;
                  if (faceEl) faceEl.classList.add("is-cutout");
                }
              });
            });
          } else if (resolvePlacement(form, mockupConfig).shape === "sticker") {
            makeStickerCutout(file).then(function (url) {
              if (url && token === cutoutToken && fileInput.files.length) {
                previewImg.src = url;
                if (faceEl) faceEl.classList.add("is-cutout");
                var bgEl = mockupEl.querySelector("[data-mockup-bg]");
                if (bgEl) bgEl.hidden = true;
                mockupEl.classList.add("mockup-preview--plain");
              }
            });
          } else {
            if (resolvePlacement(form, mockupConfig).bg === "black") {
              makeDarkBackground(file).then(function (darkUrl) {
                if (darkUrl && token === cutoutToken && fileInput.files.length) {
                  previewImg.src = darkUrl;
                }
              });
            }
            detectFaceCrop(file).then(function (res) {
              if (res && token === cutoutToken && fileInput.files.length) {
                var pl = resolvePlacement(form, mockupConfig);
                var useEyes = res.eyes && pl.h < pl.w * 0.6;
                faceCrop = useEyes ? res.eyes : res.face;
                applyCropStyles(previewImg, faceCrop);
              }
            });
          }
        }
      });
      if (removeBtn) {
        removeBtn.addEventListener("click", function () {
          cutoutToken++;
          faceCrop = null;
          fileInput.value = "";
          preview.classList.remove("has-photo");
          applyCropStyles(previewImg, null);
          if (mockupEl) mockupEl.classList.remove("has-photo");
          if (faceEl) faceEl.classList.remove("is-cutout");
          if (mockupEl) mockupEl.classList.remove("mockup-preview--plain");
        });
      }
    }

    form.querySelectorAll("[data-qty-btn]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var input = form.querySelector('input[name="quantity"]');
        var value = parseInt(input.value, 10) || 1;
        value += parseInt(btn.getAttribute("data-qty-btn"), 10);
        input.value = Math.max(1, Math.min(99, value));
      });
    });

    form.querySelectorAll('input[data-swatch]').forEach(function (input) {
      input.addEventListener("change", function () {
        var image = input.getAttribute("data-variant-image");
        if (image) {
          var mainImg = document.querySelector("[data-gallery-main] img");
          if (mainImg) { mainImg.src = image; mainImg.srcset = ""; }
        }
        syncMockupPreview();
      });
    });

    form.addEventListener("submit", function (e) {
      clearError();
      var submitter = e.submitter || document.activeElement;
      var isAddToCart = !!(submitter && submitter.closest && submitter.closest("[data-add-to-cart]"));
      var mode = isAddToCart ? "drawer" : form.getAttribute("data-cart-mode") || "checkout";
      var activeBtn = isAddToCart ? atcBtn : buyBtn;
      var activeLabel = isAddToCart ? atcLabel : buyLabel;
      var hasFile = fileInput && fileInput.files.length > 0;

      if (requirePhoto && fileInput && !hasFile) {
        e.preventDefault();
        showError("Please upload a photo first!");
        fileInput.closest(".photo-uploader__zone") &&
          fileInput.closest(".photo-uploader__zone").scrollIntoView({ block: "center", behavior: "smooth" });
        return;
      }

      /* File uploads must go through the native multipart POST to /cart/add —
         Shopify only stores file line-item properties on a non-AJAX cart post. */
      if (hasFile) {
        if (mockupEl) injectPreviewProps(form, resolvePlacement(form, mockupConfig), faceCrop);
        var returnTo = form.querySelector('input[name="return_to"]');
        if (!returnTo) {
          returnTo = document.createElement("input");
          returnTo.type = "hidden";
          returnTo.name = "return_to";
          form.appendChild(returnTo);
        }
        returnTo.value = mode === "checkout" ? "/checkout" : window.location.pathname + "?cart=open";
        if (buyBtn) buyBtn.setAttribute("disabled", "disabled");
        if (atcBtn) atcBtn.setAttribute("disabled", "disabled");
        if (activeLabel) activeLabel.textContent = "Uploading your photo…";
        return;
      }

      e.preventDefault();
      var originalLabel = activeLabel ? activeLabel.textContent : "";
      if (buyBtn) buyBtn.setAttribute("disabled", "disabled");
      if (atcBtn) atcBtn.setAttribute("disabled", "disabled");
      if (activeLabel) activeLabel.textContent = fileInput && fileInput.files.length ? "Uploading your photo…" : "Adding…";

      var formData = new FormData(form);
      fetch(routes.cartAdd, { method: "POST", body: formData })
        .then(function (r) { return r.json().then(function (json) { return { ok: r.ok, json: json }; }); })
        .then(function (result) {
          if (!result.ok || result.json.status) {
            throw new Error(result.json.description || result.json.message || "Could not add to cart. Please try again.");
          }
          if (mode === "checkout") {
            if (activeLabel) activeLabel.textContent = "Heading to checkout…";
            window.location.href = routes.checkout;
          } else {
            if (buyBtn) buyBtn.removeAttribute("disabled");
            if (atcBtn) atcBtn.removeAttribute("disabled");
            if (activeLabel) activeLabel.textContent = originalLabel;
            openDrawer();
          }
        })
        .catch(function (err) {
          showError(err.message || "Something went wrong. Please try again.");
          if (buyBtn) buyBtn.removeAttribute("disabled");
          if (atcBtn) atcBtn.removeAttribute("disabled");
          if (activeLabel) activeLabel.textContent = originalLabel;
        });
    });
  });

  /* ---------- Gallery thumbnails ---------- */
  document.querySelectorAll("[data-gallery]").forEach(function (gallery) {
    var main = gallery.querySelector("[data-gallery-main] img");
    gallery.querySelectorAll("[data-gallery-thumb]").forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        if (!main) return;
        main.src = thumb.getAttribute("data-image");
        main.srcset = "";
        gallery
          .querySelectorAll("[data-gallery-thumb]")
          .forEach(function (t) { t.classList.remove("is-active"); });
        thumb.classList.add("is-active");
      });
    });
  });

  /* ---------- Video sound toggles (one unmuted at a time) ---------- */
  var soundButtons = document.querySelectorAll("[data-video-sound]");
  soundButtons.forEach(function (btn) {
    btn.addEventListener("click", function () {
      var card = btn.closest(".video-card");
      var video = card && card.querySelector("video");
      if (!video) return;
      var wasUnmuted = btn.classList.contains("is-unmuted");
      soundButtons.forEach(function (other) {
        other.classList.remove("is-unmuted");
        var otherCard = other.closest(".video-card");
        var otherVideo = otherCard && otherCard.querySelector("video");
        if (otherVideo) otherVideo.muted = true;
        other.setAttribute("aria-label", other.getAttribute("aria-label").replace(/^Mute/, "Unmute"));
      });
      if (!wasUnmuted) {
        video.muted = false;
        btn.classList.add("is-unmuted");
        btn.setAttribute("aria-label", btn.getAttribute("aria-label").replace(/^Unmute/, "Mute"));
      }
    });
  });

  /* ---------- Sticky mobile cart bar ---------- */
  var stickyBar = document.querySelector("[data-sticky-cart]");
  var purchaseCard = document.querySelector(".purchase-card");
  if (stickyBar && purchaseCard && "IntersectionObserver" in window) {
    new IntersectionObserver(
      function (entries) {
        stickyBar.classList.toggle("is-visible", !entries[0].isIntersecting);
      },
      { rootMargin: "-80px 0px 0px 0px" }
    ).observe(purchaseCard);
    stickyBar.querySelector("button, a") &&
      stickyBar.querySelector("button, a").addEventListener("click", function (e) {
        e.preventDefault();
        purchaseCard.scrollIntoView({ behavior: "smooth", block: "start" });
      });
  }

  /* ---------- Reviews carousel ---------- */
  document.querySelectorAll("[data-review-carousel]").forEach(function (carousel) {
    var scroller = carousel.querySelector("[data-review-scroller]");
    var prevBtn = carousel.querySelector("[data-review-prev]");
    var nextBtn = carousel.querySelector("[data-review-next]");
    var dots = Array.prototype.slice.call(carousel.querySelectorAll("[data-review-dot]"));
    if (!scroller) return;
    var cards = Array.prototype.slice.call(scroller.children);
    var activeIndex = 0;

    function updateActive() {
      var center = scroller.scrollLeft + scroller.clientWidth / 2;
      var closest = 0;
      var closestDist = Infinity;
      cards.forEach(function (card, i) {
        var cardCenter = card.offsetLeft + card.offsetWidth / 2;
        var dist = Math.abs(cardCenter - center);
        if (dist < closestDist) {
          closestDist = dist;
          closest = i;
        }
      });
      activeIndex = closest;
      dots.forEach(function (dot, i) {
        dot.classList.toggle("is-active", i === activeIndex);
      });
      if (prevBtn) prevBtn.disabled = activeIndex === 0;
      if (nextBtn) nextBtn.disabled = activeIndex === cards.length - 1;
    }

    function scrollToIndex(index) {
      var clamped = Math.max(0, Math.min(cards.length - 1, index));
      var card = cards[clamped];
      if (!card) return;
      scroller.scrollTo({
        left: card.offsetLeft - (scroller.clientWidth - card.offsetWidth) / 2,
        behavior: "smooth",
      });
    }

    scroller.addEventListener("scroll", updateActive, { passive: true });
    window.addEventListener("resize", updateActive);
    if (prevBtn) prevBtn.addEventListener("click", function () { scrollToIndex(activeIndex - 1); });
    if (nextBtn) nextBtn.addEventListener("click", function () { scrollToIndex(activeIndex + 1); });
    dots.forEach(function (dot, i) {
      dot.addEventListener("click", function () { scrollToIndex(i); });
    });
    updateActive();
  });

})();

/* build 12 */
